var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1184 4.01071L10.2756 0.167857C10.1684 0.0607143 10.0238 0 9.87199 0H2.28627C1.9702 0 1.71484 0.255357 1.71484 0.571429V15.4286C1.71484 15.7446 1.9702 16 2.28627 16H13.7148C14.0309 16 14.2863 15.7446 14.2863 15.4286V4.41607C14.2863 4.26429 14.2256 4.11786 14.1184 4.01071ZM12.9684 4.67857H9.6077V1.31786L12.9684 4.67857ZM13.0006 14.7143H3.00056V1.28571H8.39342V5.14286C8.39342 5.34177 8.47243 5.53254 8.61309 5.67319C8.75374 5.81384 8.9445 5.89286 9.14342 5.89286H13.0006V14.7143ZM8.57199 7.28572C8.57199 7.20714 8.5077 7.14286 8.42913 7.14286H7.57199C7.49342 7.14286 7.42913 7.20714 7.42913 7.28572V9.21429H5.50056C5.42199 9.21429 5.3577 9.27857 5.3577 9.35714V10.2143C5.3577 10.2929 5.42199 10.3571 5.50056 10.3571H7.42913V12.2857C7.42913 12.3643 7.49342 12.4286 7.57199 12.4286H8.42913C8.5077 12.4286 8.57199 12.3643 8.57199 12.2857V10.3571H10.5006C10.5791 10.3571 10.6434 10.2929 10.6434 10.2143V9.35714C10.6434 9.27857 10.5791 9.21429 10.5006 9.21429H8.57199V7.28572Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file-add.8aa9f013be54adbe787fcd7ec80dd900.svg";
export { ForwardRef as ReactComponent };